<!-- HEADER -->
<div [class.header-border]="true"
       [class.overlay-toolbar]="true">
    <lm-toolbar
      [toolbarIdPrefix]="'adhocsearch'"
      [automationId]="'adhocsearch'"
      [inHeader]="false"
      [isInOverlay]="true"
      [showOverlayBackButton]="false"
      [allowOverlayInteractions]="false"
      [sectionTitle]="'Filter Options'"
      [buttons]="toolbarButtons"
      [showCalledOutMenuButton]="false"

      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
      ></lm-toolbar>
  </div>
<!-- MAIN CONTENT-->
 <div class="lm-adhoc-flyout scrollable">
    @if (facadeFields && facadeFields.length > 0) {
        <!-- SEARCH FORM -->
        <div class="lm-base-search-form-wrapper">

            <lm-form-content-search #baseSearchForm
                [model]="this.overlayInfo.adHocSearchInfo.model"
                [formSpec]="this.overlayInfo.adHocSearchInfo.formSpec"
                [formOptions]="this.overlayInfo.adHocSearchInfo.formOptions"
                [specFields]="this.overlayInfo.adHocSearchInfo.specFields"
                [layout]="this.overlayInfo.adHocSearchInfo.layout"
                [suppressSearchButtons]="true"
                [isAdHoc]="false"
            ></lm-form-content-search>
        </div>
        <div class="lm-adhoc-search-form-wrapper">
            @if (this.newFormSpec) {
                <lm-form-content-search #adHocSearchForm
                    [model]="this.overlayInfo.adHocSearchInfo.model"
                    [formSpec]="this.newFormSpec"
                    [formOptions]="this.overlayInfo.adHocSearchInfo.formOptions"
                    [specFields]="this.newFormSpec.busFormSpec.fields"
                    [layout]="this.newFormSpec.busFormSpec.busFormLayoutSpec.layout"
                    [isAdHoc]="true"
                    [suppressSearchButtons]="true"
                    (fieldEvent)="removeField($event)"
                ></lm-form-content-search>
            }
        </div>

        <!-- FACADE FIELDS EXPANDABLE SECTION -->
        <soho-expandable-area class="lm-hide-footer lm-adhoc-all-expandable" [closed]="false">
            <soho-expandable-header>
                <div class="header-container" (click)="toggleHeader($event)"
                    id="lm-adhoc-all-expandable-header" data-automation-id="lm-adhoc-all-expandable-header">
                    <span>{{allHeader}}</span>
                    @if (selectedExpandableOpen) {
                        <svg soho-icon icon="chevron-down"></svg>
                    }
                    @if (!selectedExpandableOpen) {
                        <svg soho-icon icon="chevron-up"></svg>
                    }
                </div>
            </soho-expandable-header>
            <soho-expandable-pane>
                <div class="lm-adhoc-search-wrapper">
                    <form (ngSubmit)="doTextSearch()" class="lm-searchfield-form">
                    <span soho-searchfield-wrapper>
                        <input soho-searchfield
                               [placeholder]="'Search'"
                               [clearable]="true"
                               id="lm-adhoc-search-fields-search"
                               data-automation-id="lm-adhoc-search-fields-search"
                               name="lm-adhoc-search-fields-search"
                               enterkeyhint="search"
                               [(ngModel)]="searchValue"
                               [ngModelOptions]="{standalone: true}"
                               (cleared)="clearTextSearch()"
                        />
                    </span>
                    </form>
                </div>

                <div class="lm-adhoc-available-fields-wrapper">
                    @for (field of displayedFacadeFields; track field; let i = $index) {
                        @if (!(field.selected || field.hidden)) {
                            <div class="lm-adhoc-facade-field">
                                <span>{{field.name}}</span>
                                <button type="button"><svg soho-icon icon="add" (click)="addField(field.bindId)"></svg></button>
                            </div>
                        }
                    }
                </div>
            </soho-expandable-pane>
        </soho-expandable-area>

    }
 </div>
<div class="lm-adhoc-buttons-wrapper">
    <button id="lm-adhoc-clear-button" type="button" class="btn-secondary" (click)="onClear()"><span>Clear</span></button>
    <button id="lm-adhoc-apply-button" type="button" class="btn-primary" (click)="onApply($event)"><span>Apply</span></button>
</div>
